import PostDisbursalTab from "./PostDisbursalTab";
export default PostDisbursalTab;
